import axios from 'axios';
import {
  AboutHero,
  BelieveSection,
  TeamSection,
  JoinAlmabetter,
} from '../components/local/about-us';
import PressHighlights from '../components/shared/PressHighlights';
import SiteHeader from '../components/shared/SiteHeader';

import { getStrapiURL } from '../lib/api';
const apiBaseUrl = getStrapiURL();
export default function AboutUs({ pressHighlights, error, aboutUs, teams }) {
  return (
    <>
      <SiteHeader
        title={aboutUs.attributes.seo?.MetaTitle}
        desc={aboutUs.attributes.seo?.MetaDescription}
        url={aboutUs.attributes.seo?.MetaUrl}
        image={aboutUs.attributes.seo?.image?.data?.attributes?.url}
      />
      <div className="container-default-1209px">
        <AboutHero />
        <BelieveSection attributes={aboutUs.attributes.believeSection} />
        <TeamSection teams={teams} />
        <div className="mt-48">
          <PressHighlights pressHighlights={pressHighlights} showSeeMore={true} />
        </div>
        <JoinAlmabetter />
      </div>
    </>
  );
}

export async function getStaticProps() {
  try {
    const { data: pressHighlights } = await axios.get(
      `${apiBaseUrl}/api/press-hightlight?populate=highlights.image`
    );
    const { data: aboutUs } = await axios.get(
      `${apiBaseUrl}/api/about?populate=believeSection.features&populate=believeSection.image&populate=seo.image`
    );
    const { data: teams } = await axios.get(
      `${apiBaseUrl}/api/teams?populate=image&pagination[page]=0&pagination[pageSize]=70&sort[0]=position`
    );
    return {
      props: {
        pressHighlights: pressHighlights.data || {},
        aboutUs: aboutUs.data || {},
        teams: teams.data || {},
      },
      revalidate: 3600,
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
}
